Realize.i18n.registerLocale({
	actions: {
		add: 'Adicionar dados na tabela',
		mobileAdd: 'Adicionar',
		update: "Atualizar",
		close: 'Fechar',
		back: 'Voltar',
		create: 'Criar',
		confirm: 'Confirmar',
		import: 'Importar',
	},

	error: 'Erro',
	by: 'por',
	overwrite: 'sobrescrever',
	warningExpandedGroup: 'Grupo não possui a opção "expandir e contrair grupo" configurada no Studio',
	groupWithoutField: 'Grupo não possui o campo informado',
	warningEventSubscribeGroup: 'Esse evento não esta implementado para agrupador',
	from: 'de',

	erro: {
		button: {
			close: 'Fechar mensagem de erro'
		}
	},

	masks: {
		cep: "99999-999",
		cnpj: "99.999.999/9999-99",
		cpf: "999.999.999-99",
		telefone: "(99) 9999-9999",
		celular: "(99) [9]9999-9999",
		decimal: {
			alias: "decimal",
			groupSeparator: ".",
			radixPoint: ",",
			removeMaskOnSubmit: true,
			autoGroup: true,
			digitsOptional: false,
			integerDigits: 10,
			digits: 2,
			placeholder: "0",
			clearMaskOnLostFocus: false
		},
		currency: {
			alias: "currency",
			prefix: "R$ ",
			groupSeparator: ".",
			radixPoint: ",",
			placeholder: "0",
			removeMaskOnSubmit: true,
			integerDigits: 10,
			digits: 2
		}
	},

	grid: {
		mathFuncitons: {
			operatorErrorType: "A coluna que deseja fazer o calculo, precisa ser do tipo Numérico, Decimal ou Monetário"
		}
	},

	datepicker: {
		monthsFull: [ 'janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro' ],
		monthsShort: [ 'jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez' ],
		weekdaysFull: [ 'domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado' ],
		weekdaysShort: [ 'dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab' ],
		today: 'hoje',
		clear: 'limpar',
		close: 'fechar'
	},

	history: {
		title: 'Histórico',
		activity: 'Atividade',
		responsible: 'Responsável pela atividade',
		date: 'Data',
		by: 'por',
		in: 'em',
		show: "Mostrar histórico",
		hide: "Esconder histórico"
	},

	form: {
		validations: {
			required: 'Este campo é obrigatório.',
			fields_required: 'Existem campos obrigatórios para serem preenchidos'
		},
		errors: {
			error_default: 'Por favor, verifique o(s) erro(s) abaixo.',
			unknown_error: 'Erro inesperado.',
			required_file_type: 'Tipo de arquivo é um campo obrigatório',
			null_pointer_exception: 'Erro inesperado.',
			user_not_found: 'Usuário não encontrado. Este problema provavelmente foi causado por uma perda de sessão, efetue um novo login e tente novamente.',
			activity_not_defined: 'A próxima atividade não foi definida.',
			action_to_assign_user_not_permited: 'Você não possui permissão para redirecionar esta atividade para outro usuário. Apenas os gestores do processo podem realizar esta ação.',
			user_route_not_informed: 'Usuário não informado para a rota.',
			invalid_route: 'Roteamento inválido.',
			invalid_action_type: 'Roteamento inválido.',
			user_scaling_defined_not_exists: 'Escalonamento para usuário inválido.',
			function_scaling_defined_not_exists: 'Escalonamento para função inválido.',
			user_scaling_not_defined: 'Escalonamento para usuário não definido.',
			group_scaling_defined_not_exists: 'Escalonamento para grupo inválido.',
			user_inactive_for_scaling: 'Usuário inativo para escalonamento',
			user_alternative_scaling_defined_not_exists: 'Escalonamento para usuário inválido.',
			activity_executed: 'Atividade já executada.',
			sql_not_executed: 'Erro ao executar SQL. Verifique os campos que estão configurados com o tipo inicialização como "Resultado de select" ou na configuração de "Resultado de select por página.',
			invalid_environment_mode: 'Modo de acesso inválido, trocar para de teste ou normal.',
			invalid_environment_mode: 'Modo de acesso inválido, trocar para teste ou normal.',
			invalid_environment_mode_subprocess: 'O modo de acesso (normal ou teste) deve ser o mesmo entre processo e subprocesso.',
			user_defined_not_exists: 'Roteamento informado inválido.',
			group_not_exist: 'Grupo inválido.',
			access_denied: 'O usuário não tem permissão de acesso.',
			access_denied_for_activity_instance: 'O usuário não tem permissão de acesso.',
			is_public: 'O usuário selecionado como publico não é o mesmo usuário que está como responsável da atividade.',
			script_invalid: 'Não foi possível determinar a próxima atividade pois o script configurado nesta atividade não é válido.',
			subprocess_referenced_not_configured: 'A chamada para o subprocesso não foi configurada corretamente.',
			behavior: {
				event:{
					invalid_element: 'Falha ao interpretar o motor de regras: Não foi possível adicionar um evento ao campo, pois o campo não existe no modelo ou está oculto nessa atividade!'
				},
				action:{
					invalid_element: 'Falha ao interpretar o motor de regras: Não foi possível executar uma ação em um determinado elemento, pois o elemento não existe no modelo ou está oculto nessa atividade!'
				}
			},
			are_all_inputs_hidden: 'Todos os campos desta atividade estão ocultos ou invisíveis.',
			process_definition_permition: 'Sem permissão para abrir o processo.',
			table_not_generated: 'A tabela da próxima instância não foi gerada.',
			process_has_been_canceled: 'O processo já foi cancelado.',
			integration_in_lock: 'Há uma ação está em andamento, atualize a página em alguns instantes para verificar o status da atividade.',
			alternative_user_not_exist: 'Usuário substituto não cadastrado',
			invalid_date: 'Data inválida',
			sub_process_non_actived: 'Falha ao iniciar o Subprocesso, verifique com o Gestor deste modelo se o mesmo está publicado (ativo).'
		},
		warnings: {
			max_length_numeric_api: 'Valor @ excede o máximo permitido de'
		},
		messages: {
			info_required: '(*) Campos de preenchimento obrigatório.',
			info_warning_external_manipulation: '(!) Valores de campos numéricos/monetários excederam o tamanho máximo permitido.'
		},
		errorExecuteAction: 'Ocorreu um erro ao executar esta ação.',
		errorPossibleExecuteAction: 'Não foi possível executar esta ação.',
		warnNotPropAPILabel: 'O componente do tipo label não contém essa propriedade em sua estrutura.',
		invalid_text_value_size: 'O tamanho do campo não esta dentro do valor aceito pelo banco.'		
	},

	template: {
		defaultLabel: 'Template',
		titles: {
			create: 'Criar Documento',
			import: 'Importar Documento',
			attach: 'Anexar Documento',
			manage: 'Gerenciar Documento',
			detachOrDelete: 'Desvincular ou Excluir Documento',
			detach: 'Desvincular Documento',
			delete: 'Excluir Documento',
			handleDuplicate: 'Tratar Documento Duplicado',
			handleDivergentVersions: 'Versões Divergentes',
			documentProperties: 'Propriedades do Documento',
			documentFields: 'Campos do Documento',
			fileData: 'Dados do Arquivo',
			digitalSignature: 'Assinar Documento'
		},
		actions: {
			create: 'Criar',
			import: 'Importar',
			attach: 'Anexar',
			manage: 'Gerenciar',
			detach: 'Desvincular',
			delete: 'Excluir',
			search: 'Pesquisar',
			onlyDetach: 'Apenas Desvincular',
			checkout: 'Check-out',
			cancelCheckout: 'Cancelar Edição',
			checkin: 'Check-in',
			overwrite: 'Sobrescrever',
			duplicate: 'Duplicar',
			downloadDocument: 'Baixar documento',
			showGraph: 'Mostrar gráfico',
			hideChart: 'Esconder gráfico',
			selectVersion: 'Sim',
			notOverwrite: 'O documento selecionado não pode ser sobrescrito, pois foi incluído através de processo.',
			digitalSignature: 'Assinatura Digital',
			downloadDigitalSignature: 'Baixar Assinador',
			sortAscText: 'Ordenar de A - Z',
			sortDescText: 'Ordenar de Z - A',
			sortAscNumber: 'Ordenar de 1 - 9',
			sortDescNumber: 'Ordenar de 9 - 1',
			previewDocument: 'Visualizar documento'
		},
		messages: {
			processing: 'Processando',
			gridDetachModal: 'As ações de desvincular ou excluir serão efetivadas imediatamente na célula do documento no grid.',
			detachOrDelete: 'Deseja além de desvincular, também excluir este documento?',
			detach: 'Tem certeza que deseja desvincular este documento?',
			delete: 'Tem certeza que deseja excluir este documento?',
			documentReadonly: 'Arquivo bloqueado para edição.',
			documentLockedForCheckout: 'Este documento não pode ser aberto para edição neste momento.',
			handleDuplicate: 'Este documento já existe, você deseja duplicá-lo?',
			handleDivergentVersions: 'O arquivo atual não pode ser editado pois existe uma nova versão. Deseja selecionar a última versão do arquivo para realizar a edição?',
			handleCheckoutUndone: 'O checkin não pode ser realizado, pois o arquivo atual não possui lock para edição.',
			file_type_restriction_exception: 'Não foi possível realizar a ação, pois o tipo do documento não é permitido.',
			profile_can_not_edit_document: 'Você não possui permissão para executar esta ação no template.',
			licenseECM: 'Opção indisponível para o tipo de licença atual do ECM.',
			allowedFileTypes: 'Não foi possível realizar o upload do documento. Apenas arquivo .@@type@@ é permitido.',
			allowedFileTypesSize: 'Não foi possível realizar o upload do documento. Apenas arquivo .@@type@@ e com o tamanho menor que ##size## Kb são permitidos.',
			maxFileSizeAllowed: 'Não foi possível realizar o upload do documento. Pois o tamanho do arquivo ##size## Kb é maior que o permitido.',
			noDigitalSign: 'Assinador Lecom não encontrado. Caso já tenha instalado, entre em contato com o suporte.',
			connectingDigitalSignService: 'Conectando serviço de assinatura. Aguarde...',
			waitingForTheSignedDocument: 'Aguardando documento assinado...',
			documentUploadedSignature: 'Documento assinado com sucesso.',
			canceledDigitalSignature: 'A assinatura do documento foi cancelada.',
			signatureFailure: 'A assinatura do documento falhou.',
			notPermssionDigitalSign: 'Você não possui permissão para assinar documento!',
			errorCompatibility: 'A versão do assinado Lecom esta desatualizada. Favor atualizar a versão.',
			errorDigitalSignature: 'Erro ao conectar com o assinador. Caso o problema persista, entre em contato com o suporte.',
			previewDocumentNotEnabled: 'Visualização de documento disponível apenas em modo normal'
		},
		attributes: {
			file: 'Arquivo',
			fileType: 'Tipo do Arquivo',
			fileName: 'Nome do Arquivo',
			author: 'Autor',
			version: 'Versão',
			currentVersion: 'Versão Atual',
			createdAt: 'Data de criação'
		}
	},

	processInstance: {
		status: 'Status',
		code: 'Código'
	},

	modal: {
		loading: 'Aguarde! Carregando...',
		lupa: {
			warningSelectLupa: 'Falha ao executar o filtro. Verifique as configurações do modelo.'
		},
		editGridModal: 'Edite os dados',
		createGridModal: 'Insira os dados'
	},

	process: {
		description: 'Descrição do processo',
		helpText: 'Ajuda',
		helpModalTitle: 'Informações',
		assignToUserModelTitle: 'Redirecionar',
		actions: {
			cancel: 'Cancelar',
			finish: 'Finalizar'
		},
		messages: {
			processFinished: 'Processo finalizado'
		},
		status: {
			COMPLETED: 'APROVADO',
			REJECTED: 'REJEITADO'
		},
		helpTitle: 'Ajuda do processo',
		helpDesc: 'Descrição',
		helpDescEmpty: 'Nenhuma descrição',
		helpTextModal: 'Texto de ajuda',
		helpTextEmpty: 'Nenhum texto de ajuda',
		helpFile: 'Arquivo',
		helpFileDownload: 'Baixar arquivo de ajuda',
		helpFileEmpty: 'Nenhum arquivo'
	},

	activity: {
		cycle: 'Ciclo',
		due_date: 'Prazo da Atividade',
		start_date: 'Início da Atividade',
		finish_date: 'Finalização da Atividade',
		actions: {
			approve: 'Aprovar',
			reject: 'Rejeitar',
			openLookup: 'Abrir Lupa'
		},
		toolbox: {
			toolboxName: "Ações",
			saveActivity: 'Salvar',
			downloadProcessHelpFile: 'Arquivo de ajuda',
			assignToUser: 'Redirecionar para outro usuário',
			markActivityAsUnread: 'Marcar como não lida',
			openTimeLine: 'Abrir fluxo',
			cancelProcess: 'Cancelar Processo',
			printForm: 'Imprimir',
			openProcessHelpModal: "Informações",
			openAssignActivityToUserModal: "Atribuir atividade"
		},
		assignToUserModal: {
			selectUser: 'Selecione um usuário para redirecionamento',
			selectUserWarning: 'Antes de confirmar o redirecionamento, selecione um usuário!'
		},
		messages: {
			nextActivity: 'Próxima atividade',
			nextResponsibles: 'Próximos responsáveis',
			activityFinished: 'Atividade gravada com sucesso',
			activityCancelled: 'Atividade cancelada com sucesso!',
			multipleApprovalFailed: 'Não foi possível efetuar a aprovação automática, pois a atividade não permite aprovação!',
			multipleRejectionFailed: 'Não foi possível efetuar a rejeição automática, pois a atividade não permite rejeição!',
			integration: 'Integration',
			executed: 'executada',
			concentratorActivity: 'Atividade concentradora',
			concentratorActivityWithPendingActivities: 'Esta é uma atividade concentradora, e será liberada quando todas as atividades em paralelo forem concluídas.',
			activityBlocked: 'Atividade bloqueada',
			finalActivity: 'Atividade de Finalização',
			subProcess: 'Uma nova instância do processo foi aberta: Código'
		},
		status: {
			CANCELLED: 'Cancelado',
			IN_PROGRESS: 'Em Andamento',
			APPROVED: 'Aprovado',
			REJECTED: 'Rejeitado',
			EXCLUDED: 'Excluído',
			HIBERNATED: 'Hibernado',
			HIBERNATING: 'Em Hibernação',
			LATE: 'Atrasado',
			FINALIZED: 'Finalizado',
			OPENING: 'Em abertura',
			SCHEDULED: 'Escalonado',
		}
	},

	successResponseMessages: {
		saveActivity: 'Os dados da atividade foram gravados com sucesso.',
		cancelProcess: 'O processo foi cancelado com sucesso.',
		markActivityAsUnread: 'A atividade foi marcada como "não lida" com sucesso.',
		assignActivityToUser: 'Atividade redirecionada com sucesso. Usuário responsável pela próxima atividade:',
		assignActivityToUserTitle: 'Atividade redirecionada com sucesso!'
	},

	confirmMessages: {
		cancelProcess: 'Tem certeza que deseja cancelar este processo? Esta ação é irreversível.'
	},

	javascript: {
		errors: {
			noLoad: "Falha ao carregar script customizado definido nesta atividade."
		}
	},

	table: {
		columnActions: 'Ações',
		emptyResult: 'Nenhum dado adicionado',
		emptyResultSearcher: 'Nenhum dado encontrado'
	},

	general: {
		date: {
			format_date: 'Preencher no formato',
			format: 'dia, mês e ano',
			invalid: 'não é válido',

		},
		button: {
			edit: 'Editar',
			delete: 'Deletar',
			download: 'Download',
			help_modal: 'Botão modal ajuda'
		},
		description:{
			refresh: 'Refresh - Pressione a tecla enter para carregar um valor automático.',
			date: 'Data - Pressione a tecla enter para abrir a modal de seleção de data.',
			magnifying_glass: 'Lupa - Pressione a tecla enter para acessar a modal e realizar uma pesquisa.'
		},
		textarea: {
			maxlength: 'Quantidade de caracteres digitado é @ no máximo de #.'
		},
		error: {
			close: 'Fechar mensagem de erro.'
		},
		success: {
			close: 'Fechar mensagem.'
		},
		new_document: 'Criar um novo documento.',
		not_attached_document: 'Importar um novo documento.',
		attach_document: 'Anexar um novo documento.',
		document_create: 'O documento @ foi criado.',
		attach_document_form: 'O documento @ foi anexado ao formulário.',
		group_label: 'Esconder ou mostrar conteúdo do formulário - o estado atual é @',
		close: 'fechado',
		open: 'aberto',
		select: 'Selecione',
		open_options: 'Pressione espaço para abrir as opções @.',
		options_selected: 'Opção selecionada @',
		not_options_selected: 'Nem uma opção selecionada',
		search: {
			options: 'Opção @ focada, # de & resultados disponíveis. Use Tab para ir para proxima opção ou Tab + shift para voltar a opçao anterior, pressione Enter para selecionar a opção atualmente focada, pressione Esc para sair do menu.'
		},
		empty_result_list: 'Nenhum item foi encontrado.',
		show_help_text: 'Pressione Enter para abrir modal de ajuda.',
		filter_to: 'Perquisar por @ ou ir para lista usando o tab ou o direcional para baixo'
	},

	importMultipleModal: {
		modalTitle: 'Importar múltiplos arquivos',
		modalTitleGrid: 'Importar múltiplos arquivos na grid',
		selectDocumentFieldsDefault: 'Escolha um campo para vincular ao arquivo',		
		filesListErrors: {
			emptyDocuments: 'O arquivo está sem vínculo com um campo',
			alreadyFileLinked: 'O campo já contém um arquivo importado',					
			emptyFieldsMetadata: 'metadados',
			emptyFieldsGrid: 'campos da grid',
			emptyFieldsAnd: 'e',
			emptyFieldsBegin: 'Existem',
			emptyFieldsEnd: 'para serem preenchidos',
			duplicatedDocuments: 'Há duplicação de dados, clique no ícone para resolver',
			divergentVersionInCheckin: 'Há divergência entre as versões no checkin',
			checkoutUndone: 'Esse documento já está bloqueado para checkin',				
			document_not_associeted_process_instance_exception: "Documento não associado à instância do processo",
			document_not_found: "Documento não encontrado",
			document_locked: "Documento bloqueado",
			profile_can_not_edit_document: "Seu perfil não pode editar o documento",
			wrong_version: "Versão errada",
			profile_has_no_access_on_template: "O perfil não tem acesso ao modelo",
			file_required: "O arquivo é obrigatório",
			version_collision: "Esta versão já existe",
			document_major_version: "Existe uma versão principal para este documento",
			checkout_not_performed: "Este documento não tem bloqueio de edição",
			document_locked_for_override: "Documento bloqueado para substituição",
			invalid_file_name: "O arquivo contém um caractere inválido no nome (: ? * \" < > | \\)",			
			missing_params_exception: "Parâmetros ausentes",
			ecm_file_not_found: "Arquivo ECM não encontrado",
			file_type_restriction_exception: "O template não permite o tipo '@'",
			file_size_restriction_exception: "O arquivo excedeu o tamanho máximo permitido de @ Kb configurado no template",
			document_cannot_be_deleted_exception: "O documento não pode ser excluído",
			file_session_already_closed_exception: "Sessão de arquivo já fechada",
			file_session_not_found_exception: "Sessão de arquivo não encontrada",
			file_not_found_in_storage_exception: "Arquivo não encontrado",						
		},
		dropZone: 'Arraste e solte seus arquivos aqui ou clique para selecioná-los',
		successImport: 'Arquivo importado com sucesso',
		removeFile: 'Remover arquivo da lista de importação',
		metadataFields: 'Preencher metadados',
		importing: 'Importando...',
		fillLineFields: 'Preencher campos da linha'
	}

}, 'pt-BR');
